export default "__VITE_ASSET__DIPxOt3Z__"